var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 16.7502C2.5 16.7502 7.20101 27.2502 16 27.2502C24.799 27.2502 29.5 16.7502 29.5 16.7502C29.5 16.7502 24.799 6.25024 16 6.25024C7.20101 6.25024 2.5 16.7502 2.5 16.7502ZM4.17448 16.7502C4.30018 16.9892 4.46401 17.2883 4.6654 17.6312C5.21077 18.5596 6.02159 19.7922 7.08389 21.0178C9.23742 23.5025 12.2347 25.7502 16 25.7502C19.7653 25.7502 22.7626 23.5025 24.9161 21.0178C25.9784 19.7922 26.7892 18.5596 27.3346 17.6312C27.536 17.2883 27.6998 16.9892 27.8255 16.7502C27.6998 16.5113 27.536 16.2122 27.3346 15.8693C26.7892 14.9409 25.9784 13.7083 24.9161 12.4827C22.7626 9.99796 19.7653 7.75024 16 7.75024C12.2347 7.75024 9.23742 9.99796 7.08389 12.4827C6.02159 13.7083 5.21077 14.9409 4.6654 15.8693C4.46401 16.2122 4.30018 16.5113 4.17448 16.7502Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 16.751C19.75 18.8216 18.0706 20.5002 15.9993 20.5002C13.9283 20.5002 12.25 18.822 12.25 16.751C12.25 14.6784 13.9284 13.0002 15.9993 13.0002C18.0704 13.0002 19.75 14.6787 19.75 16.751Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.e6a5cf2b635e618917eae8013120819d.svg";
export { ForwardRef as ReactComponent };